'use client';

import { useEffect } from 'react';
import { VpnError } from '@frameio/next-shared/components/VpnError';
import { VPN_CONNECTION_ERROR_MESSAGE } from '@frameio/next-shared/utils/errorConstants';
import { ServerErrorLayout } from '@frameio/shared/layouts/ServerErrorLayout';
import { datadogLogger } from '@frameio/telemetry/datadog/logger';

export default function ErrorPage({ error }: { error: Error }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Error found server side:', error);

    if (error?.message !== VPN_CONNECTION_ERROR_MESSAGE) {
      datadogLogger.error('Error Page Rendered', error);
    }
  }, [error]);

  if (error?.message === VPN_CONNECTION_ERROR_MESSAGE) {
    return <VpnError />;
  }

  return <ServerErrorLayout />;
}
